module.exports = "<div [chart]=\"chart\" id=\"chart\" ></div>\n"